module.exports = __webpack_public_path__ + "web_static/img/yellowline2.e46a6366.gif";